import { AppFeedback } from 'components/appFeedback/AppFeedback';
import { ActionButton, ButtonPanel } from 'components/secondaryMarket/shared/status';
import { useNavigateTo } from 'hooks/useNavigateTo';
import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { secondaryMarketOrderBlotterFilterByOrderId } from 'state/blotters/secondaryMarketOrderBlotter';
import { RoutePath } from 'state/router';
import type { ThunkDispatch } from 'state/state.common';

export function OrderPlacedActionButtons({
  onDone,
  hasOrderBlotter = false,
  onNavigateToBlotter: onNavigateToOrdersBlotter,
  blotterRoute,
}: OrderPlacedActionButtonsProps) {
  const navigateToOrderBlotter = useNavigateTo(blotterRoute);

  return (
    <ButtonPanel>
      <AppFeedback
        withGuidedTour={false}
        Button={({ toggle }) => (
          <ActionButton
            onClick={() => {
              toggle();
              logAnalytics.trackEvent('Secondary market', 'Open order feedback modal');
            }}
            label="secondaryMarket.sidePanel.label.pricingFeedbackMessage"
            isFlat
            color="secondary"
            icon="reviews"
          />
        )}
      ></AppFeedback>
      <div className="btn-group my-1 w-100">
        {onDone && (
          <ActionButton
            color="discreet-secondary"
            label="secondaryMarket.sidePanel.label.ok"
            e2e="closeOrderButton"
            className="w-50"
            disabled={false}
            onClick={onDone}
          />
        )}
        {hasOrderBlotter && (
          <ActionButton
            color="default"
            label="secondaryMarket.sidePanel.label.viewInBlotter"
            e2e="viewTradeBlotterButton"
            className="w-50"
            disabled={false}
            onClick={() => {
              onNavigateToOrdersBlotter();
              logAnalytics.trackEvent('Secondary market', 'View in trade blotter');
              navigateToOrderBlotter();
            }}
          />
        )}
      </div>
    </ButtonPanel>
  );
}

type OrderPlacedActionButtonsDispatchProps = {
  onNavigateToBlotter: () => void;
};

type OrderPlacedActionButtonsOwnProps = {
  onDone?: (closeTab?: boolean) => void;
  hasOrderBlotter?: boolean;
  blotterRoute: RoutePath;
  orderId?: string;
};

export type OrderPlacedActionButtonsProps = OrderPlacedActionButtonsDispatchProps & OrderPlacedActionButtonsOwnProps;

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { orderId }: OrderPlacedActionButtonsOwnProps,
): OrderPlacedActionButtonsDispatchProps => {
  return {
    onNavigateToBlotter: () => {
      dispatch(secondaryMarketOrderBlotterFilterByOrderId(orderId));
    },
  };
};

export const connectOrderPlacedActionButtons = connect(null, mapDispatchToProps);

export const ConnectedOrderPlacedActionButtons = connectOrderPlacedActionButtons(OrderPlacedActionButtons);
